export const ORDER_STATUS_COLORS = {
  pending: 'black',
  inserted: 'grape',
  waitingConfirmation: 'orange',
  waitingPayment: 'orange',
  processingPayment: 'orange',
  confirmed: 'blue',
  production: 'yellow',
  closed: 'green',
  refunded: 'gray',
};

export const ORDER_STATUS_STRINGS = {
  pending: 'Non inviato al gestionale',
  inserted: 'In elaborazione',
  waitingConfirmation: 'Attesa di conferma',
  waitingPayment: 'Attesa di pagamento',
  processingPayment: 'Pagamento in corso',
  confirmed: 'Confermato',
  production: 'In produzione',
  closed: 'Spedito',
  refunded: 'Rimborsato',
};
